import React from 'react';
import PropTypes from 'prop-types';
import { useLabels } from 'wsm-common-data';

const FilterItem = ({ id, label, type, isDefault, handleFilterRemove }) => {
	const labels = useLabels();

	const handleClick = (e) => {
		e.preventDefault();
		if (isDefault) return;
		handleFilterRemove(type, id);
	};

	return (
		<button
			type="button"
			className="pill chip chip-default chip-condensed facet-filter"
			onClick={handleClick}
			disabled={isDefault}
			aria-disabled={isDefault}
			aria-label={
				isDefault
					? label
					: labels
							.get('FILTER_VALUE_CLICK_TO_REMOVE')
							.replace('{filter}', type)
							.replace('{value}', label)
			}
		>
			{label} {!isDefault && <i className="ddc-icon ddc-icon-remove2" />}
		</button>
	);
};

FilterItem.propTypes = {
	id: PropTypes.string.isRequired,
	label: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	isDefault: PropTypes.bool,
	handleFilterRemove: PropTypes.func.isRequired
};

FilterItem.defaultProps = {
	isDefault: false
};

export default FilterItem;
